import React from 'react'
import Lottie from "lottie-react";
// import LoadingAnimation from "../animations/Progress Bar.json";
import loadingAnimation from "../animations/Abstract Isometric Loader #1.json";
import "./LoadingAnimation.css"

const LoadingAnimation = () => {
    return (
        <div className="lottie-crop">
            <Lottie animationData={loadingAnimation} loop />
        </div>
    )
}

export default LoadingAnimation